export default __webpack_public_path__ + "static/forgery_equipment_upgrade-87878d9870ea9214b9e904ba918d535c.png";